export const CUSTOM_404_STRINGS = {
  title: 'What planet are we on?',
  description: 'Looks like the page you were headed to no longer exists.',
};
